/**
 * @generated SignedSource<<87b2265349516101dc864657196b94a9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RefinementBar$data = {
  readonly jira: {
    readonly allJiraProjectCategories?: {
      readonly edges: ReadonlyArray<{
        readonly __typename: "JiraProjectCategoryEdge";
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectCategoryPicker" | "ProjectTypePicker">;
  } | null | undefined;
  readonly " $fragmentType": "RefinementBar";
};
export type RefinementBar$key = {
  readonly " $data"?: RefinementBar$data;
  readonly " $fragmentSpreads": FragmentRefs<"RefinementBar">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isAnonymous"
    }
  ],
  "kind": "Fragment",
  "name": "RefinementBar",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "isAnonymous",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "cloudId",
                  "variableName": "cloudId"
                }
              ],
              "concreteType": "JiraProjectCategoryConnection",
              "kind": "LinkedField",
              "name": "allJiraProjectCategories",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraProjectCategoryEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "__typename"
                    }
                  ]
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectCategoryPicker"
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "ProjectTypePicker"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "3a9e892b53f5bea57b40dd90d8e6cb22";

export default node;
